import {
  CheckIfExistsActionTypes,
  CheckIfExistsState,
  CHECK_IF_EXISTS_BY_ID_FAILURE,
  CHECK_IF_EXISTS_BY_ID_REQUEST,
  CHECK_IF_EXISTS_BY_ID_SUCCESS,
  CHECK_IF_EXISTS_FAILURE,
  CHECK_IF_EXISTS_REQUEST,
  CHECK_IF_EXISTS_SUCCESS,
} from './types';

const defaultState: CheckIfExistsState = {
  isLoading: false,
  errorMessage: '',
  exists: false,
};

function checkIfExists(state = defaultState, action: CheckIfExistsActionTypes): CheckIfExistsState {
  switch (action.type) {
    case CHECK_IF_EXISTS_REQUEST:
    case CHECK_IF_EXISTS_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CHECK_IF_EXISTS_SUCCESS:
    case CHECK_IF_EXISTS_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorMessage: '',
        exists: action.exists,
        existingRequestData: action.existingRequestData,
      };
    case CHECK_IF_EXISTS_FAILURE:
    case CHECK_IF_EXISTS_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: '',
      };
    default:
      return state;
  }
}

export default checkIfExists;
